// 네이티브 앱과 통신하는 유틸 파일 - 통합로그인
import LocalStorageUtil from 'src/utils/localStorageUtil';

import { deviceOsType } from './constants/deviceOsConstants';
import { storageConstants } from './constants/storageConstants';

// os 분기 함수
const getDeviceOS = () => {
  const os = localStorage.getItem(storageConstants.deviceOS);
  return os ? os.toLowerCase() : null;
};

// 네이티브앱 호출 함수
export const callLoginNative = (token: any) => {
  try {
    console.log('[학습자] 통합로그인 함수 실행');
    const deviceOS = getDeviceOS();
    LocalStorageUtil.removeSkipPasswordData();

    const filteredLocalStorage = filterIconifyKeys(window.localStorage);
    const localStorageData = JSON.stringify(filteredLocalStorage);

    if (deviceOS === deviceOsType.ios) {
      if (window?.webkit?.messageHandlers?.callLoginApp) {
        window.webkit.messageHandlers.callLoginApp.postMessage({
          token,
          userData: localStorageData,
        });
      }
      return;
    }

    if (deviceOS === deviceOsType.android) {
      AndroidBridge.callLoginApp(token, localStorageData);
    }
  } catch (error) {
    console.log('[학습자] 통합로그인 함수 실행 에러 : ', error);
  }
};

// 로컬 스토리지 필터링 함수
const filterIconifyKeys = (data: Record<string, any>): Record<string, any> => {
  const filteredData: Record<string, any> = {};
  Object.keys(data).forEach((key) => {
    if (!key.includes(storageConstants.iconify)) {
      filteredData[key] = data[key];
    }
  });
  return filteredData;
};
